import { useCallback } from 'react';
import { useSdkMutation } from '@/provider';

export type UseFeedbackProps = {
  object: string;
  metadata?: Record<string, unknown>;
};

export function useFeedback({ object, metadata }: UseFeedbackProps) {
  const [feedback, createFeedback] = useSdkMutation(
    `feedback:${object}`,
    (sdk, args: { rating: number; comment?: string }) => {
      return sdk.feedback.create({
        object,
        rating: args.rating,
        comment: args.comment,
        metadata,
      });
    }
  );

  const rate = useCallback(
    (rating: number, comment?: string) => {
      void createFeedback({ rating, comment });
    },
    [createFeedback]
  );

  return [feedback, rate] as const;
}
